import React from "react";
import { Box } from "@mui/material";

export const NetworkStrengthIcon = ({ strength = 0 }) => {
  const levels = [1, 2, 3, 4, 5];
  const activeBars = levels.map((level) => strength >= level);

  const barStyles = [
    { height: "5px" },
    { height: "7px" },
    { height: "9px" },
    { height: "11px" },
    { height: "13px" },
  ];

  return (
    <Box
      sx={{
        width: "19px",
        height: "15px",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
      }}
    >
      {barStyles.map((style, index) => (
        <Box
          key={index}
          sx={{
            width: "3px",
            borderRadius: "1px",
            backgroundColor: activeBars[index] ? "#2C2C2C" : "#C4C4C4",
            ...style,
          }}
        />
      ))}
    </Box>
  );
};
